import React, { useState, useEffect, useContext } from 'react';
import useAsyncEffect from 'use-async-effect';
import Inputs from 'components/inputs/inputs';
import Flow from 'components/common/flow/flow';
import Heading from 'components/common/heading/heading';
import Panel from 'components/common/panel/panel';
import Datatable from 'components/common/datatable/datatable';
import Pager from 'components/common/pager/pager';
import AppContext from 'contexts/appContext';
import BoardingService from 'services/boardingService';
import moment from 'moment';

export default function BoardingDashboardPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setAppArea(AppContext.Areas.Boarding, 'Boarding Dashboard');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Boarding', selected: true }]);
  }, []);

  useAsyncEffect(async () => {
    const pagedResult = await BoardingService.API.getOrderDashboard({ pageSize: 10, pageOffset: (currentPage - 1) * 10 })
    setData(pagedResult.results);
    setPageCount(Math.ceil(pagedResult.totalRecords / 10));
    setLoaded(true);
  }, [currentPage]);

  const handleRowClick = (row) => {
    if (row?.id) {
      props.history.push(`/Boarding/Order/${row.id}`);
    }
  };

  if (!loaded) {
    return null;
  }
  return (
    <Flow>
      <Flow.Header>
        <Heading>
          <div className='flex-grow-1 d-flex justify-content-end'>
            <Inputs.Button variant='primary' href='/Boarding/Wizard' iconClass='icons8-plus-math' label='Board Sites' />
          </div>
        </Heading>
      </Flow.Header>

      <Flow.Body>
        <div className='row justify-content-md-center mx-0 mt-4'>
          <div className='col-md-12 col-xl-10'>
            <Panel>
              <Panel.Header>Boarding Dashboard</Panel.Header>
              <Panel.Body>
                <Datatable columns={columns} data={data} onRowClick={handleRowClick} />
                <Pager className='mb-1' align='left' active={currentPage} pages={pageCount} onChange={setCurrentPage} />
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </Flow.Body>
    </Flow>
  );
}

const rowSelected = (value, cell) => {
  //empty, will be overriden
};

const storeProgressColumn = (value, cell) => {
  if (value < 20) {
    return (
      <div>
        <div className='badge badge-light-danger'><i className='icons8-box-important' /> Lacking Store Number</div>
        <Inputs.Button variant='hover-default' size='xs' className='ml-1'>Fix Now</Inputs.Button>
      </div>
    );
  }
  if (value < 40) {
    return (
      <div>
        <div className='badge badge-light-danger'><i className='icons8-box-important' /> Lacking Address</div>
        <Inputs.Button variant='hover-default' size='xs' className='ml-1'>Fix Now</Inputs.Button>
      </div>
    );
  }
  if (value < 60) {
    return (
      <div>
        <div className='badge badge-light-danger'><i className='icons8-box-important' /> Lacking Phone</div>
        <Inputs.Button variant='hover-default' size='xs' className='ml-1'>Fix Now</Inputs.Button>
      </div>
    );
  }
  return <div className='badge badge-light-success'><i className='icons8-checkmark' /> Good</div>;
};

const agentProgressColumn = (value, cell) => {
  if (value === 1) {
    return <div className='badge badge-light-success'><i className='icons8-checkmark' /> Connected</div>;
  }
  if (value === 0) {
    return <div className='badge badge-light-danger'><i className='icons8-box-important' /> Not Connected</div>;
  }
  return null;
};

const licenseProgressColumn = (value, cell) => {
  return null;
};

const registrationProgressColumn = (value, cell) => {
  if (value === 1) {
    return <div className='badge badge-light-success'><i className='icons8-checkmark' /> Registered</div>;
  }
  if (value === 0) {
    return <div className='badge badge-light-danger'><i className='icons8-box-important' /> Not Registered</div>;
  }
  return null;
};

const userProgressColumn = (value, cell) => {
  return null;
};

const verificationColumn = (value, cell) => {
  const storeProgress = cell.row.values['storeProgress'];
  const agentProgress = cell.row.values['agentProgress'];
  //const licenseProgress = cell.row.values['licenseProgress'];
  //const registrationProgress = cell.row.values['pregistrationProgress'];
  //const userProgress = cell.row.values['userProgress'];

  if (storeProgress >= 60 && agentProgress >= 1) {
    return <Inputs.Button variant='success' iconClass='icons8-start' label='Verify' />;
  }
  return <span>Not Ready</span>;
};

const columns = [
  {
    accessor: 'id',
    isVisible: false,
  },
  {
    Header: 'Site',
    accessor: 'storeName',
    width: 220,
  },
  {
    Header: 'Dealer',
    accessor: 'dealerName',
    width: 240,
  },
  /*{
    Header: 'Enterprise',
    accessor: 'enterpriseName',
    width: 200,
  },*/
  {
    Header: 'Key Number',
    accessor: 'keyId',
  },
  {
    Header: 'Boarding Start Date',
    accessor: 'created',
    format: (d) => moment(d).format('L LT'),
  },
  {
    Header: 'Progress',
    accessor: 'stepsCompletedCount',
    width: 225,
    progressBlocks: [
      {
        value: 1,
        color: '#23c6c8',
      },
      {
        value: 2,
        color: '#23c6c8',
      },
      {
        value: 3,
        color: '#23c6c8',
      },
      {
        value: 4,
        color: '#23c6c8',
      },
      {
        value: 5,
        color: '#23c6c8',
      },
      {
        value: 6,
        color: '#23c6c8',
      },
      {
        value: 7,
        color: '#1ab394',
      },
      {
        value: 8,
        color: '#1ab394',
      },
    ],
  },
  {
    Header: 'Current Step',
    accessor: 'currentStepName',
    width: 210,
  },
];